import { notify } from 'utils/reduxUtils';

export const types = {
  CONFORMANCE_LANGUAGE_FETCH_SUCCESS:
    'settings/profile/CONFORMANCE_LANGUAGE_FETCH_SUCCESS',
  CONFORMANCE_LANGUAGE_UPDATE_ERROR:
    'settings/profile/CONFORMANCE_LANGUAGE_UPDATE_ERROR',
  CONFORMANCE_LANGUAGE_UPDATE_REQUEST:
    'settings/profile/CONFORMANCE_LANGUAGE_UPDATE_REQUEST',
  CONFORMANCE_LANGUAGE_UPDATE_SUCCESS:
    'settings/profile/CONFORMANCE_LANGUAGE_UPDATE_SUCCESS',
};

export const conformanceLanguageFetch = {
  success: ({ conformanceLanguage }) => ({
    type: types.CONFORMANCE_LANGUAGE_FETCH_SUCCESS,
    payload: { conformanceLanguage },
  }),
};

export const conformanceLanguageUpdate = {
  error: notify(
    (error) => ({
      type: types.CONFORMANCE_LANGUAGE_UPDATE_ERROR,
      payload: error,
    }),
    "Can't update conformance language.",
  ),
  request: ({ conformanceLanguage }) => ({
    type: types.CONFORMANCE_LANGUAGE_UPDATE_REQUEST,
    payload: { conformanceLanguage },
  }),
  success: notify(
    ({ conformanceLanguage }) => ({
      type: types.CONFORMANCE_LANGUAGE_UPDATE_SUCCESS,
      payload: { conformanceLanguage },
    }),
    'Conformance language updated.',
  ),
};
